import Vue from 'vue'
import Vuex from 'vuex'
import message from './common/message'
import noData from './common/noData'
import version from './common/version'
import users from './modules/users'
import occupations from './modules/occupations'
import auth from './modules/auth'
import recoverPassword from './modules/recoverPassword'
import services from './modules/services'
import offers from './modules/offers'
import stats from './modules/stats'
import unavailabilityDates from './modules/unavailabilityDates'
import timeCodes from './modules/timeCodes'
import replacementMotives from './modules/replacementMotives'
import contracts from './modules/contracts'
import dashboard from './modules/dashboard'
import userKit from './modules/userKit'
import hubs from './modules/hubs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    message,
    noData,
    version,
    users,
    occupations,
    recoverPassword,
    services,
    offers,
    auth,
    stats,
    unavailabilityDates,
    timeCodes,
    replacementMotives,
    contracts,
    dashboard,
    userKit,
    hubs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js